export const Popup_Toast = {
    MULTI_STEP_FORM: {
        OTP_LIMIT: {
            content:{
                title:  "OTP Limit Reached",
                description: 'Maximum of 3 OTP requests reached. Please try again later.'
            }
        },
        BACK_ONBOARDING: {
            content:{
                title:  "Discard Changes?",
                description: 'Returning to the login page will discard any unsaved changes. Do you want to continue?'
            }
        }
    },
    LOGOUT_CONFIRMATION: {
        content:{
            title:  "Log Out",
            description: 'Are you sure you want to log out?'
        }
    },
    DELETE_IMAGE: {
        content:{
            title:  "Delete Image",
            description: 'Are you sure you want to delete the selected'
        }
    },
    DELETE_CATALOG: {
        content:{
            title:  "Delete Catalogue",
            description: 'Are you sure you want to delete this item?'
        }
    },
    AD_CREATION: {
        SHOW_MOBILE_PREVIEW: {
            content: "Please add a poster to continue."
        }
    },
    CONTACT_ACCESS: {
        SUCCESSFULLY: {
            content: "User contact fetched successfully."
        },
        LIMIT_REACHED: {
            content: "You have reached your contact access limit."
        }
    },
    BACK_WITHOUT_PAYMENT: {
        content: "Your ad has been created. You’ll be redirected to the listing page in 6 seconds"
    },
    BUSINESS_INFO_SAVED: {
        content: {
            title:'Updates in Review',
            description: "Your changes are under review by our team. This process may take between 24 and 72 hours."
        }
    },
    CHANGE_PHONE_NUMBER: {
        content: {
            content: 'Mobile Number changed successfully.'
        }
    }
};
